import { createSlice } from '@reduxjs/toolkit';
import {
  drugSearchSuggestionsThunk,
  drugSearchAutocompleteThunk,
  drugSearchThunk,
} from './thunks';

const enhancedDrugSearchSlice = createSlice({
  name: 'enhancedDrugSearch',
  initialState: {
    suggestions: {
      isLoading: false,
      searchText: '',
      suggestions: [],
      isOffline: false,
    },
    autoComplete: {
      isLoading: false,
      searchText: '',
      queryPlusText: '',
    },
    drugSearch: {
      isLoading: false,
      isOffline: false,
      displaySearchResults: false,
      drugResults: [],
    },
  },
  reducers: {
    clearDrugSearchAutoComplete: (state) => {
      state.autoComplete = {
        ...state.autoComplete,
        queryPlusText: '',
      };
    },
    clearDrugSearchResults: (state) => {
      state.drugSearch = {
        isLoading: false,
        isOffline: false,
        displaySearchResults: false,
        drugResults: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(drugSearchSuggestionsThunk.pending, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          isLoading: true,
          searchText: action.meta.arg.searchText,
        };
      })
      .addCase(drugSearchSuggestionsThunk.fulfilled, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          suggestions: action.payload.suggestions,
          isOffline: action.payload.isOffline,
          isLoading: false,
        };
      })
      .addCase(drugSearchSuggestionsThunk.rejected, (state, action) => {
        state.suggestions = {
          ...state.suggestions,
          isOffline: true,
          isLoading: false,
        };
      })
      .addCase(drugSearchAutocompleteThunk.pending, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          isLoading: true,
          queryPlusText: '',
          searchText: action.meta.arg.searchText,
        };
      })
      .addCase(drugSearchAutocompleteThunk.fulfilled, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          queryPlusText: action.payload.queryPlusText,
          isLoading: false,
        };
      })
      .addCase(drugSearchAutocompleteThunk.rejected, (state, action) => {
        state.autoComplete = {
          ...state.autoComplete,
          queryPlusText: '',
          isLoading: false,
        };
      })
      .addCase(drugSearchThunk.pending, (state, action) => {
        state.drugSearch = {
          ...state.drugSearch,
          searchText: action.meta.arg.searchText,
          isLoading: true,
          drugResults: [],
          displaySearchResults: false,
        };
      })
      .addCase(drugSearchThunk.fulfilled, (state, action) => {
        const updateResultsIfSearchTextMatchesCurrentSearchText = () => {
          return action.payload.searchParams.searchText ===
            state.drugSearch.searchText
            ? action.payload.drugResults
            : state.drugSearch.drugResults;
        };

        state.drugSearch = {
          ...state.drugSearch,
          drugResults: updateResultsIfSearchTextMatchesCurrentSearchText(),
          isOffline: action.payload.isOffline,
          isLoading: false,
          displaySearchResults: true,
        };
      })
      .addCase(drugSearchThunk.rejected, (state, action) => {
        state.drugSearch = {
          ...state.drugSearch,
          isOffline: true,
          isLoading: false,
          drugResults: [],
          displaySearchResults: false,
        };
      });
  },
});

export default enhancedDrugSearchSlice.reducer;

export const { clearDrugSearchAutoComplete, clearDrugSearchResults } =
  enhancedDrugSearchSlice.actions;

export const selectDrugSearchSuggestions = (state) =>
  state.drugSearchSlice.suggestions.suggestions;
export const selectDrugSearchResults = (state) =>
  state.drugSearchSlice.drugSearch.drugResults;
export const selectDrugSearchIsLoading = (state) =>
  state.drugSearchSlice.drugSearch.isLoading;
export const selectDisplayDrugSearchResults = (state) =>
  state.drugSearchSlice.drugSearch.displaySearchResults;
export const selectDrugSearchAutoCompleteQueryPlusText = (state) =>
  state.drugSearchSlice.autoComplete.queryPlusText;
